import React, { useState, useEffect, useRef } from 'react';
import './MoodSelection.css';
import MoodIcon from '../MoodIcon/MoodIcon';
import RangeInput from '../RangeInput/RangeInput';
import validate from '../../common/validate';
import logComponent from '../../common/logComponent';

export default function MoodSelection({ initialValue, showError, errorMessage, rules, onValidate, name }) {
  const [nativeInputValue, setNativeInputValue] = useState(+initialValue > 0 && +initialValue <= 10 ? +initialValue : 1);
  const [selectedMood, setSelectedMood] = useState(+initialValue > 0 && +initialValue <= 10 ? +initialValue : null);
  const [validationDetails, setValidationDetails] = useState(null);
  const [isValid, setIsValid] = useState(null);
  const [needsValidate, setNeedsValidate] = useState(false);
  const isValidating = useRef(false);

  if (logComponent('MoodSelection')) { console.debug('MoodSelection render'); }

  useEffect(() => {
    if (logComponent('MoodSelection')) { console.debug('MoodSelection onMount'); }
    if (!isValidating.current) validateThis();
  }, [])

  useEffect(() => {
    if (logComponent('MoodSelection')) { console.debug('MoodSelection useEffect [needsValidate]'); }
      if (needsValidate === true) {
        if (!isValidating.current) validateThis();;
        setNeedsValidate(false);
      }
  }, [needsValidate])

  const validateThis = () => {
    if (logComponent('MoodSelection')) { console.debug('MoodSelection validateThis'); }
    isValidating.current = true;
    let validationDetailsThis = [];
    for (let rule in rules) {
      validationDetailsThis.push({
        rule: rule,
        valid: validate[rule](selectedMood, rules[rule])
      })
    }
  
    let isValidThis = validationDetailsThis.reduce((prev, curr) => prev && curr.valid, true);

    setValidationDetails(validationDetailsThis);
    setIsValid(isValidThis);

    onValidate({
      name: name,
      isValid: isValidThis,
      value: selectedMood
    });
    isValidating.current = false;
  }

  const updateSelectedMood = (newMood) => {
    if (logComponent('MoodSelection')) { console.debug('MoodSelection updateSelectedMood'); }
    setSelectedMood(newMood);
    setNeedsValidate(true);
  }

  return (
    <div className="Mood-Selection">
      {
        showError && !isValid &&
        <p className="Mood-Selection__error">{errorMessage}</p>
      }
      <h4 className="Mood-Selection__heading">
        Mood selection
        {
          rules && rules.required &&
          <span className="Mood-Selection__required"> *</span>
        }
      </h4>
      <div className="Mood-Selection__body">
        <div className="Mood-Selection__slider">
          <RangeInput
            min={1}
            max={10}
            startAtNull={selectedMood === null}
            initial={nativeInputValue}
            onChange={updateSelectedMood}
            onBlur={validateThis}
            showNumbers={false}
            showLabels={false}
            showGraphics={false}
            labels={null}
            graphics={null}
            alwaysShowOptions={false}

          />
        </div>
        <div className="Mood-Selection__icon">
          <MoodIcon mood={selectedMood} />
        </div>
      </div>
    </div>
  );
}